import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
// import { HotelProvider } from './context/HotelContext';
import { HotelProvider } from './HotelContext';
// import UploadPage from './components/UploadPage';
import UploadPage from './UploadPage';

function App() {
    return (
        <HotelProvider>
            <UploadPage/>
        </HotelProvider>
    );
}

export default App;